import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { selectedInvoiceIdKey } from '~/components/global/constants';

/**
 * Opens an invoice or proposal at `/spending/:invoiceId`.
 *
 * For the call sites that open one from a click handler rather than a link — the
 * spending grid's row click and chat's invoice cards. The current search string rides
 * along so the global date range and filters survive the jump; `selectedInvoiceId` is
 * dropped so {@link DetailParamRedirects} doesn't bounce the page it just opened.
 */
export function useOpenInvoice(): (invoiceId: string) => void {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(
    (invoiceId: string) => {
      const search = new URLSearchParams(searchParams);
      search.delete(selectedInvoiceIdKey);
      void navigate({ pathname: `/spending/${invoiceId}`, search: search.toString() });
    },
    [navigate, searchParams],
  );
}
